import React from 'react';
import PropTypes from 'prop-types';

function Button({
  children, onClick, size = 'md', variant = 'default',
}) {
  const base = 'rounded px-3 py-1 font-medium';
  const sizes = {
    sm: 'text-sm py-1 px-2',
    md: 'text-base py-2 px-4',
  };
  const variants = {
    default: 'bg-blue-600 text-white hover:bg-blue-700',
    outline: 'border border-blue-600 text-blue-600 hover:bg-blue-50',
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${base} ${sizes[size]} ${variants[variant]}`}
      // Add more allowed props here as needed, e.g. id, disabled, aria-label
    >
      {children}
    </button>
  );
}
Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
  variant: PropTypes.oneOf(['default', 'outline']),
};

Button.defaultProps = {
  size: 'md',
  variant: 'default',
};

export default Button;
